import { colors, fonts } from '@grupoboticario/flora-tokens/eudora/web/ds'

export const eudora = {
  colors,
  fonts,
}
